import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { RestClientService } from '../../rest/rest-client.service';
import { LettreNotification } from '../model/lettre-notification';

@Injectable({
    providedIn: 'root'
  })
  export class LettreNotificationService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    getLettreNotificationByrequestId(requestId) {
      return this._restClientService.load<LettreNotification>('lettre-notification/lettre-notifications-by-requestid/'+requestId);
    }
      
    putLettreNotification(lettreNotification: LettreNotification) {
      return this._restClientService.put<void>('lettre-notification/update-lettre-notification', lettreNotification);
    }

}      

    